import { NgModule } from '@angular/core';
import { BetonCmsComponents } from '@core/const';
import { ModalComponent } from '@sdvor/shared/ui';
import { CmsConfig, ConfigModule } from '@spartacus/core';
import { BetonOrderFormModule } from '../../components';
import { BetonOrderCmsModalComponent } from './beton-order-cms-modal.component';

@NgModule({
  declarations: [BetonOrderCmsModalComponent],
  imports: [
    ConfigModule.withConfig(<CmsConfig>{
      cmsComponents: {
        [BetonCmsComponents.RosaCMSBetonOrderModalComponent]: {
          component: BetonOrderCmsModalComponent,
        },
      },
    }),
    ModalComponent,
    BetonOrderFormModule,
  ],
})
export class BetonOrderCmsModalModule {}
